import { clsx } from 'clsx';
import { ChangeEvent, FC, useMemo } from 'react';
import { Select } from 'atoms/Select';
import { useTranslations } from 'modules/i18n/useTranslations';
import { Arranging, SortOptions } from 'commerce/factFinder/queryParameters';
import { useFilters } from '../hooks';
import styles from '../FilterItem/styles.module.css';

export const Sorting: FC = () => {
  const { sortOptions, sortBy, setSortBy } = useFilters();
  const t = useTranslations();

  // Filter out sort options that are not in the SortOptions enum
  const sortingOptions = useMemo(() => {
    const tMap = {
      asc: t('search.sort.asc'),
      desc: t('search.sort.desc'),
      priceValue: t('search.sort.priceValue'),
      headline: t('search.sort.headline'),
      ratingScore: t('search.sort.rating'),
      Relevancy: t('search.sort.Relevancy'),
    };

    // sort items by index in SortOptions enum
    const sortItems = (a: { name: SortOptions }, b: { name: SortOptions }) => {
      const findIndex = (name: SortOptions) =>
        Object.values(SortOptions).indexOf(name);
      return findIndex(a.name) - findIndex(b.name);
    };

    return sortOptions
      ?.filter(({ name }) => Object.values(SortOptions).includes(name))
      .map(({ name, order }) => {
        const fieldText = tMap[name];
        const orderText = tMap[order];

        return {
          label: `${fieldText} ${name === SortOptions.relevancy ? '' : orderText}`,
          value: `${name} ${order}`,
          name,
        };
      })
      .sort(sortItems);
  }, [sortOptions, t]);

  const handleSortChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const [field, direction] = e.target.value.split(' ') as [
      SortOptions,
      Arranging,
    ];

    setSortBy({ field, direction });
  };

  return !sortOptions ? null : (
    <Select
      className={clsx(styles.filter, styles.selectContainer)}
      classes={{ select: styles.select }}
      options={sortingOptions}
      onChange={handleSortChange}
      value={`${sortBy?.field} ${sortBy?.direction}`}
    />
  );
};
